export enum ChecklistType {
    ExitSurvey= "EXIT_SURVEY",
    AssetDeProvision = "DEPROVISION_ASSETS",
    WorkListReAssign = "WORKLIST_REASSIGN", 
    BenefitTerminationPDF = "BENEFIT_TERMINATION_PDF",
    FinalPayCheck = "FINAL_PAYCHECK",
    ObsReAssign = "OBS_REASSIGN",
    SubOrdinatesReAssign = "SUBORDINATES_REASSIGN",
    ChargeCodesReAssign = "CHARGE_CODE_REASSIGN",
    SignOpenTimesheets = "SIGN_OPEN_TIMESHEETS"
}

export enum TerminationChecklistStatusType {
    InProgress= "IN_PROGRESS",
    Rejected = "REJECTED",
    Completed = "COMPLETED",
    Error = "ERROR"
}
